import { ErrorStatusCode } from "../../config/errors.js";
const isErrorStatusCode = (value) => {
  return typeof value === "string" && Object.values(ErrorStatusCode).includes(value);
};
export {
  isErrorStatusCode
};
